import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "../../../../shared/components/dashboard-layout/modalComponent";
import "./delete-group-modal.scss";

const DeleteGroupModal = ({ isOpen, onClose, onConfirm, groupName }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      setError(null);
      await onConfirm();
    } catch (err) {
      setError(err?.message || "Failed to delete group. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSave = () => {
    if (isLoading) return;
    handleConfirm();
  };

  if (!isOpen) return null;

  return (
    <Modal
      type={"error"}
      show={isOpen}
      onClose={onClose}
      header={"Delete Group"}
      buttons={true}
      onSave={handleSave}
      saveLabel={"Delete"}
      saveDisabled={isLoading}
    >
      <div className="delete-group-modal" role="dialog" aria-modal="true">
        {error && <div className="alert alert-danger mb-3">{error}</div>}
        <p className="confirmation-message">
          Are you sure you want to delete the group <strong>{groupName}</strong>?
        </p>
        <i className="warning-text">This action cannot be undone.</i>
      </div>
    </Modal>
  );
};

DeleteGroupModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  groupName: PropTypes.string,
};

export default DeleteGroupModal;
